import { Action } from '@ngrx/store';
import { PlannerId } from '@app/models/planner-id';

export enum PlannerIdActionTypes {
  Load = '[API] Load plannerIds',
  LoadSuccess = '[API] Load plannerIds success',
  LoadFail = '[API] Load plannerIds fail',
  AddAll = '[PlannerIds] Add all'
}

export class Load implements Action {
  readonly type = PlannerIdActionTypes.Load;
  constructor() {}
}

export class LoadSuccess implements Action {
  readonly type = PlannerIdActionTypes.LoadSuccess;
  constructor(public plannerIds: PlannerId[]) {}
}

export class LoadFail implements Action {
  readonly type = PlannerIdActionTypes.LoadFail;
  constructor(public error: any) {}
}

export class AddAll implements Action {
  readonly type = PlannerIdActionTypes.AddAll;
  constructor(public plannerIds: PlannerId[]) {}
}

export type PlannerIdActionsUnion = Load | LoadSuccess | LoadFail | AddAll;
